export default __webpack_public_path__ + "static/media/Wall_Conveyor_x2_Grey.64.10fae7b0.png";